export const BATCH_ROW_LIMIT = 60000;
//# sourceMappingURL=dataLimits.js.map